<script setup lang="ts">
import type { InputNumberBlurEvent, InputNumberInputEvent, InputNumberProps } from 'primevue/inputnumber';

type Props = InputNumberProps ;
const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'blur', event: InputNumberBlurEvent): void
  (e: 'focus', value: Event): void
  (e: 'update:modelValue', value: number): void
}>();

function onInput(e: InputNumberInputEvent) {
  if (typeof e.value === 'number') {
    emit('update:modelValue', e.value);
  }
}
</script>

<template>
  <InputNumber
    v-bind="props"
    @blur="emit('blur', $event)"
    @input="onInput"
    @focus="emit('focus', $event)"
  />
</template>

<style scoped>

</style>
